<h4>Players in view</h4>
<table>
  <thead>
    <tr>
      <th class="timestamp">Player</th>
    </tr>
  </thead>
  <tbody>
    @for (player of playersInView; track player) {
      <tr>
        <td>{{ player }}</td>
      </tr>
    }
  </tbody>
</table>

<h4>Groups</h4>
<pre>{{ groups | json }}</pre>
